module.exports = __webpack_public_path__ + "img/hope.6268f62e.png";